import { generator } from '../event-listener.js';
export const OnMount = generator('onMount');
export const OnRender = generator('onRender');
export const OnUnmount = generator('onUnmount');
//# sourceMappingURL=mountable.js.map